import React, { useEffect } from "react";
import { Card, Col, Row, Typography, Flex, Spin, Result } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { css } from "@emotion/css";
import { getAllModulesAction } from "../../../../../store/action/admin/moduleActions";
import BrokenBuildingIcon from "../../../../../Theme/CustomIcons/Icons/Building/BrokenBuildingIcon";
import CalendarIcon from "../../../../../Theme/CustomIcons/Icons/Time/CalendarIcon";
import CustomGridIcon from "../../../../../Theme/CustomIcons/Icons/CustomIcons/CustomGridIcon";
import ProfileIcon from "../../../../../Theme/CustomIcons/Icons/Users/ProfileIcon";
import EmptyWalletIcon from "../../../../../Theme/CustomIcons/Icons/Money/EmptyWalletIcon";

const { Title, Text } = Typography;

const getModuleIcon = (name) => {
    switch (name.toLowerCase()) {
        case "payroll":
            return <EmptyWalletIcon size="large" />;
        case "ontrack":
            return <CalendarIcon size="large" />;
        case "auth":
            return <CustomGridIcon size="large" />;
        case "loan":
            return <BrokenBuildingIcon size="large" />;
        case "hr":
            return <ProfileIcon size="large" />;
        default:
            return <CustomGridIcon size="large" />;
    }
};

const OrganizationModules = () => {
    const dispatch = useDispatch();
    const themeDefault = useSelector((state) => state.themeDefault);
    const colorPrimary = themeDefault?.info?.colorPrimary || "#1890ff";

    const getAllModulesList = useSelector((state) => state.getAllModulesList);
    const { loading, modules, error } = getAllModulesList;

    useEffect(() => {
        dispatch(getAllModulesAction());
    }, [dispatch]);

    return (
        <Card title="Organization Modules">
            <div
                className={css`
          max-height: calc(100vh - 240px);
          overflow-y: auto;
          padding-right: 8px;
        `}
            >
                {loading ? (
                    <Flex justify="center" align="center" style={{ height: "200px" }}>
                        <Spin size="large" />
                    </Flex>
                ) : error ? (
                    <Result status="error" title="Failed to fetch modules" subTitle={error} />
                ) : (
                    <Row gutter={[16, 16]}>
                        {modules?.map((mod) => (
                            <Col span={8} key={mod._id}>
                                <Card
                                    hoverable
                                    className={css`
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    border-radius: 12px;
                    transition: all 0.3s ease;
                    &:hover {
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                      border-color: ${colorPrimary};
                    }
                  `}
                                    bodyStyle={{ padding: "20px" }}
                                >
                                    <Flex vertical gap={12}>
                                        <Flex align="center" gap={12}>
                                            <div
                                                className={css`
                          background: ${colorPrimary}15;
                          padding: 10px;
                          border-radius: 10px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: ${colorPrimary};
                        `}
                                            >
                                                {getModuleIcon(mod.module_name)}
                                            </div>
                                            <Title level={5} style={{ margin: 0, fontWeight: 700 }}>
                                                {mod.module_name}
                                            </Title>
                                        </Flex>
                                        <Text
                                            type="secondary"
                                            style={{
                                                fontSize: 13,
                                                lineHeight: "1.5",
                                                height: "40px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {mod.description}
                                        </Text>
                                        <Flex justify="space-between" align="center" style={{ marginTop: 8 }}>
                                            <Text
                                                style={{
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                    color: colorPrimary,
                                                    background: `${colorPrimary}10`,
                                                    padding: "2px 8px",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                {mod.status}
                                            </Text>
                                        </Flex>
                                    </Flex>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </div>
        </Card>
    );
};

export default OrganizationModules;
